module.exports = __webpack_public_path__ + "assets/sort-white-both.5f28bcf5.svg";